import { Component, OnInit, AfterViewInit  } from '@angular/core';
import { Http } from '@angular/http';
import { Router, ActivatedRoute, ParamMap, RoutesRecognized  } from '@angular/router';
import { PreventiveMaintenanceComponent }  from './preventive-maintenance/preventive-maintenance.component';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers:[PreventiveMaintenanceComponent]
})
export class AppComponent {
  userId:any;
  orgId:any;
  constructor(private pvm :PreventiveMaintenanceComponent, private http: Http,private router:Router,private route : ActivatedRoute) { }

  // backtoHM() {
  // 	window.history.back();
  // }
  ngOnInit() {
   // this.spinner.show();

    console.log(this.pvm);
    if(this.route.params['value'].orgId === undefined ||  this.route.params['value'].userId === undefined){
        //window.location.href = 'https://still.alshirawi.com/highmessaging/';
      } else {
        this.orgId=this.pvm._authservice.orgId;
        this.userId=this.pvm._authservice.userId;
        console.log('OrgId '+ this.orgId);
        console.log('UserId '+ this.userId);
      }
    
  }
  
  OrginalEnddate() {
    this.router.navigate(['node/orginalEndDateReport',{orgId: this.pvm._authservice.orgId,userId:this.pvm._authservice.userId}]);
  }

  pmacategory(){
    this.router.navigate(['node/pmaCategory',{orgId: this.pvm._authservice.orgId,userId:this.pvm._authservice.userId}]);
  }
  make() {
  
    this.router.navigate(['node/make',{orgId: this.pvm._authservice.orgId,userId:this.pvm._authservice.userId}]);
  }

  model() {
    this.router.navigate(['node/model',{orgId: this.pvm._authservice.orgId,userId:this.pvm._authservice.userId}]);
  }

  serviceType() {
    this.router.navigate(['node/serviceType',{orgId: this.pvm._authservice.orgId,userId:this.pvm._authservice.userId}]);
  }

  labourCost() {
    this.router.navigate(['node/labourCost',{orgId: this.pvm._authservice.orgId,userId:this.pvm._authservice.userId}]);
  }

  spareparts() {
    this.router.navigate(['node/description',{orgId: this.pvm._authservice.orgId,userId:this.pvm._authservice.userId}]);
  }

  partsdetails() {
    this.router.navigate(['node/partdetails',{orgId: this.pvm._authservice.orgId,userId:this.pvm._authservice.userId}]);
  }

  checkList() {
    this.router.navigate(['node/checkListMaster',{orgId: this.pvm._authservice.orgId,userId:this.pvm._authservice.userId}]);
  }

  creation() {
    this.router.navigate(['node/checkListDetails',{orgId: this.pvm._authservice.orgId,userId:this.pvm._authservice.userId}]);
  }

  customer() {
    this.router.navigate(['node/customerMaster',{orgId: this.pvm._authservice.orgId,userId:this.pvm._authservice.userId}]);
  }

  emirates() {
    this.router.navigate(['node/emirates',{orgId: this.pvm._authservice.orgId,userId:this.pvm._authservice.userId}]);
  }

  branch() {
    this.router.navigate(['node/branch',{orgId: this.pvm._authservice.orgId,userId:this.pvm._authservice.userId}]);
  }

  registration() {
    this.router.navigate(['node/preventiveMaintenance',{orgId: this.pvm._authservice.orgId,userId:this.pvm._authservice.userId}]);
  }

  serviceUpdation() {
    this.router.navigate(['node/serviceContract',{orgId: this.pvm._authservice.orgId,userId:this.pvm._authservice.userId}]);
  }

  due() {
    this.router.navigate(['node/ServiceDueReport',{orgId: this.pvm._authservice.orgId,userId:this.pvm._authservice.userId}]);
  }

  expiry() {
    this.router.navigate(['node/StatusReportOneMonthBefore',{orgId: this.pvm._authservice.orgId,userId:this.pvm._authservice.userId}]);
  }

  postpone() {
    this.router.navigate(['node/ThreeTimeOrMorePostponementReport',{orgId: this.pvm._authservice.orgId,userId:this.pvm._authservice.userId}]);
  }

  inactive() {
    this.router.navigate(['node/InactiveCustomerReport',{orgId: this.pvm._authservice.orgId,userId:this.pvm._authservice.userId}]);
  }

  customerContractReport() {
    this.router.navigate(['node/CustomerContractReport',{orgId: this.pvm._authservice.orgId,userId:this.pvm._authservice.userId}]);
  }

  customerMachineSummaryReport() {
    this.router.navigate(['node/CustomerMachineSummaryReport',{orgId: this.pvm._authservice.orgId,userId:this.pvm._authservice.userId}]);
  }

  customerNoContractReport() {
    this.router.navigate(['node/CustomerNoContractReport',{orgId: this.pvm._authservice.orgId,userId:this.pvm._authservice.userId}]);
  }

  dashboard() {
    this.router.navigate(['node/dashboard',{orgId: this.pvm._authservice.orgId,userId:this.pvm._authservice.userId}]);
  }

  calendar() {
    this.router.navigate(['node/calendar',{orgId: this.pvm._authservice.orgId,userId:this.pvm._authservice.userId}]);
  }
  
  SearchContract() {
    this.router.navigate(['node/history',{orgId: this.pvm._authservice.orgId,userId:this.pvm._authservice.userId}]);
  }
  
  travelCost(){
    this.router.navigate(['node/travelcost',{orgId: this.pvm._authservice.orgId,userId:this.pvm._authservice.userId}])
  }

  Sublocality(){
    this.router.navigate(['node/sublocality',{orgId: this.pvm._authservice.orgId,userId:this.pvm._authservice.userId}])
  }

  loop() {
    this.router.navigate(['node/loop',{orgId: this.pvm._authservice.orgId,userId:this.pvm._authservice.userId}])
  }

  invoiceReport() {
    this.router.navigate(['/node/invoice-report',{orgId: this.pvm._authservice.orgId,userId:this.pvm._authservice.userId}]);
  }

  // vir() {
  //   this.router.navigate(['/node/vir',{orgId: this.pvm._authservice.orgId,userId:this.pvm._authservice.userId}]);
  // }

  // addMail() {
  //   this.router.navigate(['/node/add-mail',{orgId: this.pvm._authservice.orgId,userId:this.pvm._authservice.userId}]);
  // }

 
}



// WEBPACK FOOTER //
// ./client/app/app.component.ts